export const MOVE_TO_WORKSPACE = "MOVE_TO_WORKSPACE";
export const MOVE_TO_WORKSPACE_SUCCESS = "MOVE_TO_WORKSPACE_SUCCESS";
export const MOVE_TO_WORKSPACE_FAILED = "MOVE_TO_WORKSPACE_FAILED";